import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import UiButton from './UiButton';

interface UiFilterPanelProps {
  onSearch: () => void;
  onReset?: () => void;
  loading?: boolean;
  /** Filter controls (date inputs, dropdowns, search) */
  children?: ReactNode;
  /** Extra buttons rendered in the action row alongside Reset/Search */
  actions?: ReactNode;
  // Optional built-in date range
  dateFrom?: string;
  dateTo?: string;
  onDateFromChange?: (v: string) => void;
  onDateToChange?: (v: string) => void;
}

const UiFilterPanel: React.FC<UiFilterPanelProps> = ({
  onSearch,
  onReset,
  loading = false,
  children,
  actions,
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}) => (
  <div className="bg-white dark:bg-slate-800 rounded-xl shadow-theme p-4 mb-6 flex flex-col gap-3">
    {/* Filter controls row */}
    <div className="flex flex-wrap items-end gap-4">
      {dateFrom !== undefined && (
        <div className="flex gap-2 sm:gap-4 w-full sm:w-auto min-w-0">
          <div className="flex-1 min-w-0 sm:w-[168px] sm:flex-none">
            <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">
              <FontAwesomeIcon icon={faCalendarAlt} className="mr-1" />
              วันที่เริ่มต้น
            </label>
            <input
              type="date"
              value={dateFrom}
              onChange={(e) => onDateFromChange?.(e.target.value)}
              className="w-full px-3 py-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-200 dark:focus:ring-slate-600 focus:border-gray-400 dark:focus:border-slate-500"
            />
          </div>
          <div className="flex-1 min-w-0 sm:w-[168px] sm:flex-none">
            <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">
              <FontAwesomeIcon icon={faCalendarAlt} className="mr-1" />
              วันที่สิ้นสุด
            </label>
            <input
              type="date"
              value={dateTo}
              onChange={(e) => onDateToChange?.(e.target.value)}
              className="w-full px-3 py-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-200 dark:focus:ring-slate-600 focus:border-gray-400 dark:focus:border-slate-500"
            />
          </div>
        </div>
      )}
      {children}
    </div>

    {/* Action buttons row — right-aligned, wraps on small screens */}
    <div className="flex flex-wrap justify-end gap-2">
      {actions}
      {onReset && (
        <UiButton variant="secondary" onClick={onReset}>
          รีเซ็ต
        </UiButton>
      )}
      <UiButton onClick={onSearch} loading={loading} icon={faSearch}>
        ค้นหา
      </UiButton>
    </div>
  </div>
);

export default UiFilterPanel;
